const STATUS_STYLES = {
  Pending: "bg-amber-50 text-amber-800 border-amber-300",
  "Under Review": "bg-sky-50 text-sky-800 border-sky-300",
  Scheduled: "bg-indigo-50 text-indigo-800 border-indigo-300",
  Completed: "bg-emerald-50 text-emerald-800 border-emerald-300",
};

const URGENCY_STYLES = {
  Emergency: "bg-red-50 text-crimson border-crimson/40",
  Urgent: "bg-amber-50 text-amber-800 border-amber-300",
  Routine: "bg-slate-50 text-slate-600 border-slate-300",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status.replace(/\s/g, "-").toLowerCase()}`}
    className={`font-mono text-[10px] tracking-[0.15em] uppercase px-2.5 py-1 border ${STATUS_STYLES[status] || STATUS_STYLES.Pending}`}
  >
    {status}
  </span>
);

export const UrgencyBadge = ({ urgency }) => (
  <span
    data-testid={`urgency-badge-${urgency.toLowerCase()}`}
    className={`font-mono text-[10px] tracking-[0.15em] uppercase px-2.5 py-1 border ${URGENCY_STYLES[urgency] || URGENCY_STYLES.Routine}`}
  >
    {urgency}
  </span>
);
